import { Component } from '@angular/core';

import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-edit-bet-cashout-message',
    templateUrl: 'edit-bet-cashout-message.html',
})
export class EditBetCashoutMessageComponent {
    constructor(public sitecoreMyBets: SitecoreMyBetsConfig) {}
}
